"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = function _default() {
  return null;
};

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "src/components/Configure.js");
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/components/Configure.js
// module id = 1156
// module chunks = 0